export const STEP = {
  DETAILS: 0,
  CONFIGURE: 1,
  OPTIONS: 2,
  REQUIREMENTS: 3,
};

export const STEPS = [
  { label: "Bid Details", value: STEP.DETAILS },
  { label: "Configure Bid", value: STEP.CONFIGURE },
  { label: "Configure Options", value: STEP.OPTIONS },
  { label: "Select Requirements", value: STEP.REQUIREMENTS },
];

export const BID_STATUS = {
  DRAFT: "Draft",
  ACTIVE: "Active",
};

export const OPTION = {
  AREA_TEMPLATES: "areaTemplates",
  COPY: "copyFromExisting",
  SCRATCH: "scratch",
};

export enum DOC_CATEGORY {
  PLAN = "Plan",
  SPEC = "Specification",
  OTHER = "Other",
}

export const AREA_COLUMNS = {
  LEFT: 0,
  RIGHT: 1,
};
